import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/why-us-1.jpg")